sn-hero-header-type-5 {
  .sn-hero-header-type-5 {
    position: relative;
    padding-top: px-to-rem(40px);
    padding-bottom: px-to-rem(60px);

    @include desktop {
      padding-top: px-to-rem(104px);
      padding-bottom: px-to-rem(85px);
    }

    @include above(960px) {
      padding-top: px-to-rem(100px);
      padding-bottom: px-to-rem(100px);
    }

    @include above(1200px) {
      padding-top: px-to-rem(122px);
    }
  }

  .sn-hero-header-type-5__container {
    max-width: 1312px;
    margin: 0 auto;
    padding: 0 px-to-rem(16px);

    @include desktop {
      padding: 0 px-to-rem(24px);
    }
  }

  .sn-hero-header-type-5__row {
    @include above(960px) {
      display: flex;
      align-items: flex-start;
    }
  }

  // ── Left column (details) ────────────────────────────────────────
  .sn-hero-header-type-5__column--details {
    text-align: center;

    @include above(960px) {
      flex-shrink: 0;
      width: px-to-rem(451px);
      text-align: left;
      margin-right: px-to-rem(49px);
      padding-top: px-to-rem(70px);
    }

    @include above(1200px) {
      width: px-to-rem(588px);
      margin-right: px-to-rem(92px);
      padding-top: px-to-rem(43px);
    }

    me-heading {
      font-size: px-to-rem(28px);
      line-height: px-to-rem(36px);
      margin-top: 0;
      margin-bottom: px-to-rem(12px);

      @include desktop {
        font-size: px-to-rem(36px);
        line-height: px-to-rem(48px);
        margin-bottom: px-to-rem(16px);
      }

      @include above(960px) {
        text-align: left;
        font-size: px-to-rem(48px);
        line-height: px-to-rem(60px);
        margin-bottom: px-to-rem(18px);
      }

      @include above(1200px) {
        font-size: px-to-rem(60px);
        line-height: px-to-rem(72px);
        margin-bottom: px-to-rem(20px);
      }
    }

    me-text {
      display: block;
      font-size: px-to-rem(14px);
      line-height: px-to-rem(20px);
      margin-bottom: px-to-rem(28px);

      @include desktop {
        font-size: px-to-rem(16px);
        line-height: px-to-rem(24px);
        margin-bottom: px-to-rem(40px);
      }

      @include above(960px) {
        margin-bottom: px-to-rem(22px);
      }

      @include above(1200px) {
        font-size: px-to-rem(20px);
        line-height: px-to-rem(28px);
        margin-bottom: px-to-rem(50px);
      }
    }
  }

  // ── Right column (form) ──────────────────────────────────────────
  .sn-hero-header-type-5__column--form {
    display: flex;
    justify-content: center;

    @include above(960px) {
      flex: 1;
      display: block;
    }
  }

  // ── Greeting logo pair ───────────────────────────────────────────
  .sn-hero-header-type-5__greeting {
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-bottom: px-to-rem(20px);

    @include desktop {
      margin-bottom: px-to-rem(26px);
    }

    @include above(960px) {
      justify-content: flex-start;
      margin-bottom: px-to-rem(30px);
    }

    // Both logo boxes
    > me-picture {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      width: px-to-rem(62px);
      height: px-to-rem(63px);
      border: 1px solid #81919d; // $steel-blue — no semantic token
      filter: drop-shadow(0 px-to-rem(6px) px-to-rem(20px) rgb(0 0 0 / 8%));
      border-radius: var(--radius-size-md); // 8px

      .picture,
      picture {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    // signNow logo box (first)
    > me-picture:first-child {
      margin-right: px-to-rem(29px);
      padding: px-to-rem(18px) px-to-rem(21px);

      // "+" sign between the two boxes
      &::before {
        position: absolute;
        content: '';
        top: px-to-rem(23px);
        right: px-to-rem(-38px);
        background: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIxNSIgZmlsbD0ibm9uZSI+PHBhdGggZmlsbD0iIzJDMkMyQyIgZD0iTTUuMTMyIDE0LjMxMkg3Ljk2VjguNzY4aDUuMTI0VjYuMTM2SDcuOTZWLjU5Mkg1LjEzMnY1LjU0NEguMDM2djIuNjMyaDUuMDk2eiIvPjwvc3ZnPg==')
          no-repeat;
        background-size: contain;
        width: px-to-rem(14px);
        height: px-to-rem(30px);
      }

      img {
        width: px-to-rem(18px);
        height: px-to-rem(20px);
      }
    }

    // Partner logo box (second)
    > me-picture:last-child {
      flex-direction: column;
      width: auto;
      min-width: px-to-rem(62px);
      padding: px-to-rem(10px);
      margin-left: px-to-rem(29px);

      img {
        min-height: px-to-rem(12px);
        max-height: px-to-rem(56px);
        max-width: px-to-rem(120px);
        object-fit: contain;
      }
    }
  }

  // ── Form wrapper card ─────────────────────────────────────────────
  .sn-hero-header-type-5__form-wrapper {
    display: block;
    width: 100%;
    position: relative;
    background: var(--background-color-primary); // #fff
    box-shadow: 0 px-to-rem(5px) px-to-rem(25px) 0 rgb(0 0 0 / 10%);
    padding: px-to-rem(36px) px-to-rem(16px) px-to-rem(32px);
    margin: 0 px-to-rem(-16px) px-to-rem(34px);

    @include desktop {
      border-radius: var(--radius-size-md); // 8px
      margin: 0 auto px-to-rem(56px);
      padding: px-to-rem(34px) px-to-rem(36px);
      max-width: px-to-rem(450px);

      &::after {
        position: absolute;
        content: '';
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background: #d5e6ff;
        border-radius: var(--radius-size-lg);
        transform: rotate(7deg);
        z-index: -1;
      }
    }

    @include above(960px) {
      max-width: none;
      padding: px-to-rem(40px);
      box-shadow: 0 px-to-rem(15px) px-to-rem(25px) 0 rgb(0 0 0 / 10%);
      margin: 0;
    }

    @include above(1200px) {
      box-shadow: 0 px-to-rem(20px) px-to-rem(80px) 0 rgb(0 0 0 / 10%);
      top: px-to-rem(-22px);
      padding: px-to-rem(44px) px-to-rem(52px);
    }

    me-input,
    me-select {
      display: block;
      margin-bottom: px-to-rem(17px);

      @include desktop {
        margin-bottom: px-to-rem(20px);
      }
    }

    .sn-hero-header-type-5__form-row {
      display: flex;
      gap: px-to-rem(12px);
      margin-bottom: px-to-rem(17px);

      @include desktop {
        margin-bottom: px-to-rem(20px);
      }

      me-input,
      me-select {
        flex: 1 1 0;
        min-width: 0;
        margin-bottom: 0;
      }
    }

    me-button {
      display: block;
      width: 100%;
      margin-bottom: px-to-rem(16px);

      .me-button {
        width: 100%;
      }
    }

    .sn-hero-header-type-5__agreement-note {
      display: block;
      font-size: px-to-rem(12px);
      line-height: px-to-rem(16px);
      color: var(--text-color-secondary, #666);
      margin-bottom: 0;
      text-align: center;

      a {
        color: var(--text-color-brand-primary);
        text-decoration: underline;

        &:hover {
          color: #008bf8;
        }
      }
    }
  }

  // ── Form title ────────────────────────────────────────────────────
  .sn-hero-header-type-5__form-title {
    margin-bottom: 12px;

    .me-text {
      display: block;
      max-width: px-to-rem(200px);
      margin: 0 auto px-to-rem(12px);
      font-size: px-to-rem(18px);
      line-height: px-to-rem(24px);
      font-weight: 700;
      text-align: center;

      @include desktop {
        max-width: px-to-rem(224px);
        font-size: px-to-rem(20px);
        line-height: px-to-rem(28px);
      }

      @include above(960px) {
        max-width: 100%;
        font-size: px-to-rem(24px);
        line-height: px-to-rem(32px);
      }

      @include above(1200px) {
        margin-left: 0;
        text-align: left;
      }
    }
  }

  // ── Form notice (asterisk note) ──────────────────────────────────
  .sn-hero-header-type-5__form-notice {
    margin: 0 auto px-to-rem(17px);
    font-size: px-to-rem(12px);
    line-height: px-to-rem(16px);
    color: var(--text-color-secondary, #666);
    text-align: center;

    @include desktop {
      margin-bottom: px-to-rem(20px);
    }

    @include above(1200px) {
      margin-left: 0;
      text-align: left;
    }

    me-text {
      display: block;
    }
  }
}
